export default function(data) {
  var self = this;

  self.$el = $('#admin_grading_policy_presets');
  self.$preset_modal = $('#preset_modal');

  self.grading_policy_presets = ko.observableArray();

  self.selected_preset = ko.observable();
  self.preset_mapping = {
    create: function(options) {
      var vm = ko.mapping.fromJS(options.data);
      vm.name.extend({ required: true, maxLength: 30 });
      return vm;
    }
  };
  self.new_preset = ko.observable(ko.mapping.fromJS({id: null, name: null, default: false, locked: false}, self.preset_mapping));

  self.bindData = function(data) {
    var mapped_grading_policy_presets = ko.mapping.fromJS(data.grading_policy_presets, self.preset_mapping);
    self.grading_policy_presets(mapped_grading_policy_presets());

    self.$preset_modal.off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
      self.resetSelected();
    });
  };

  self.initUI = function() {

  };

  self.resetSelected = function() {
    self.new_preset().name(null);
    self.new_preset().default(false);
    self.new_preset().locked(false);

    self.client_errors = ko.validation.group(self.new_preset(), { deep: true });
    self.selected_preset(null);
    self.client_errors.showAllMessages(false);
  };

  self.policyName = function (item) {
    var name = item.name();
    if (item.default()) {
      name += ' (';
      if (item.locked()) {
        name += 'Required ';
      }
      name += 'Default)';
    }
    return name;
  };
  /*--------------------------------------CATEGORY STATE MANAGEMENT FUNCTIONS-----------------------------------------*/

  self.addPreset = function() {
    self.selected_preset(self.new_preset());
    self.$preset_modal.modal('show');
  };

  self.editPreset = function(item, event) {
    self.selected_preset(item);
    self.$preset_modal.modal('show');
  };

  self.savePreset = function(item, event) {
    self.client_errors = ko.validation.group(self.selected_preset(), { deep: true });
    if (self.client_errors().length == 0) {
      var url = self.selected_preset().id() ? Kadenze.Routes.admin_grading_policy_preset_path(self.selected_preset().id()) : Kadenze.Routes.admin_grading_policy_presets_path();
      var data = {grading_policy_preset: ko.mapping.toJS(self.selected_preset())};
      var method = self.selected_preset().id() ? 'PATCH' : 'POST';

      Kadenze.UIUtil.makeRequest(url, method, data, self.$el, null, function(data, textStatus, xhr) {
        if (!self.selected_preset().id()) {
          self.grading_policy_presets.push(ko.mapping.fromJS(data.preset, self.preset_mapping));
        }
        self.$preset_modal.modal('hide');

        Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
      }, function(xhr, textStatus, errorThrown) {
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
      });
    } else {
      self.client_errors.showAllMessages(true);
    }
  };

  self.deletePreset = function(item, event) {
    if (item.course_count && item.course_count() > 0) {
      new Kadenze.Notice.error({title: 'Cannot Delete', message: 'Sorry, this preset is currently in use by a course.'});
      return;
    }

    var url = Kadenze.Routes.admin_grading_policy_preset_path(item.id());
    var method = 'DELETE';
    var deletePrompt = 'Are you sure you want to delete this preset?';

    Kadenze.UIUtil.confirmAction(deletePrompt, function() {
      Kadenze.UIUtil.makeRequest(url, method, null, self.$el, null, function(data, textStatus, xhr) {
        self.grading_policy_presets.remove(item);
        Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
      }, function(xhr, textStatus, errorThrown) {
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
      });
    });
  };


  const __construct = function(that) {
    console.log('constructor called for AdminPresetListingViewModel');
    that.bindData(data);
  }(this);
}
